module.exports = __webpack_public_path__ + "img/stripe_logo.e4590c1a.svg";